import React, { Component } from "react";
import CheckCircleOutlineRounded from "@mui/icons-material/CheckCircleOutlineRounded";
import { withLocalizer } from "utilities/withLocalizer";

import "./stepIndicator.css";

class StepIndicator extends Component {
    render() {
        const { data } = this.props;
        const { currentStep } = data;
        return (
            <>
                <div className="row step-indicator-container" data-testid="step-indicator">
                    <div className="step-section">
                        <div className="step-container">
                            { currentStep === 1 ? 
                                <div className="circle current-step">1</div>
                                :
                                <div className="circle check-circle"><CheckCircleOutlineRounded className="check-icon"/></div>
                            }
                            { currentStep === 1 ? 
                                <div className="splitter-line"></div>
                                :
                                <div className="splitter-line step-done"></div>
                            }
                            
                        </div>
                        <div className="step-description">
                            <div><strong>{ this.props.localize("qma-step-indicator-label-step-1") }</strong></div>
                        </div>
                    </div>
                    <div className="step-section">
                        <div className="step-container">
                            { currentStep <= 2 ? 
                                <div className={currentStep === 2 ? "circle current-step" : "circle"} >2</div>
                                :
                                <div className="circle check-circle"><CheckCircleOutlineRounded className="check-icon"/></div>
                            }
                            { currentStep > 2 ? 
                                <div className="splitter-line step-done"></div>
                                :
                                <div className="splitter-line"></div>
                            }
                        </div>
                        <div className="step-description">
                            <div><strong>{ this.props.localize("qma-step-indicator-label-step-2") }</strong></div>
                        </div>
                    </div>
                    <div className="step-section">
                        <div className="step-container">
                            { currentStep <= 3 ? 
                                <div className={currentStep === 3 ? "circle current-step" : "circle"} >3</div>
                                :
                                <div className="circle check-circle"><CheckCircleOutlineRounded className="check-icon"/></div>
                            }
                            { currentStep > 3 ? 
                                <div className="splitter-line step-done"></div>
                                :
                                <div className="splitter-line"></div>
                            }
                        </div>
                        <div className="step-description">
                            <div><strong>{ this.props.localize("qma-step-indicator-label-step-3") }</strong></div>
                        </div>
                    </div>
                    <div className="step-section">
                        <div className="step-container">
                            { currentStep <= 4 ? 
                                <div className={currentStep === 4 ? "circle current-step" : "circle"} >4</div>
                                :
                                <div className="circle check-circle"><CheckCircleOutlineRounded className="check-icon"/></div>
                            }
                            { currentStep > 4 ? 
                                <div className="splitter-line step-done"></div>
                                :
                                <div className="splitter-line"></div>
                            }
                        </div>
                        <div className="step-description">
                            <div><strong>{ this.props.localize("qma-step-indicator-label-step-4") }</strong></div>
                        </div>
                    </div>
                    <div className="step-section">
                        <div className="step-container">
                            { currentStep <= 5 ? 
                                <div className={currentStep === 5 ? "circle current-step" : "circle"} >5</div>
                                :
                                <div className="circle check-circle"><CheckCircleOutlineRounded className="check-icon"/></div>
                            }
                            { currentStep > 5 ? 
                                <div className="splitter-line step-done"></div>
                                :
                                <div className="splitter-line"></div>
                            }
                        </div>
                        <div className="step-description">
                            <div><strong>{ this.props.localize("qma-step-indicator-label-step-5") }</strong></div>
                        </div>
                    </div>
                    <div className="step-section last-section">
                        <div className="step-container">
                            { currentStep <= 6 ? 
                                <div className={currentStep === 6 ? "circle current-step" : "circle"} >6</div>
                                :
                                <div className="circle check-circle"><CheckCircleOutlineRounded className="check-icon"/></div>
                            }
                            { currentStep > 6 ? 
                                <div className="splitter-line step-done"></div>
                                :
                                <div className="splitter-line"></div>
                            }
                            { currentStep <= 7 ? 
                                <div className={currentStep === 7 ? "circle current-step" : "circle"} >7</div>
                                :
                                <div className="circle check-circle"><CheckCircleOutlineRounded className="check-icon"/></div>
                            }
                        </div>
                        <div className="step-description last-step">
                            <div>
                                <strong>{ this.props.localize("qma-step-indicator-label-step-6") }</strong>
                            </div>
                            <div>
                                <strong>{ this.props.localize("qma-step-indicator-label-step-7") }</strong>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default withLocalizer(StepIndicator);